import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/server/app.service';
import { environment } from "../../../../environments/environment"
import { Subscription } from 'rxjs';
import { InputSearchService } from './input.search.service';
export let isDebugMode = environment.isDebugMode


@Component({
    selector: 'flow-input-search',
    templateUrl: './input-search.component.html',
    styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit {

    private subscriptions: Subscription[] = []
    formControls: Array<FormControl> = []

    @Input() id: Number
    @Input() keys: any
    @Input() legend: string
    @Input() disabled: boolean = false
    @Input() form: FormGroup
    @Input() filterform: FormGroup
    @Input() tableid: Number
    @Output() eventBlur = new EventEmitter();
    @Output() eventSelect = new EventEmitter();
    @Output() eventOpenModal = new EventEmitter();

    constructor(
        private searchService: InputSearchService,
        private appService: AppService
    ) { }

    ngOnInit() {

        Object.keys(this.form.controls).forEach(key => {
            let control: any = {
                name: this.form.get(key)['name'],
                label: this.form.get(key)['label'],
                colspan: this.form.get(key)['colspan'],
                placeholder: this.form.get(key)['placeholder'],
                keyfield: this.form.get(key)['keyfield'],
                nosearch: this.form.get(key)['nosearch']
            }
            this.formControls.push(control)
        })

        this.subscriptions.push(
            this.appService.eventSelect.subscribe(data => {
                data['searchid'] = this.id
                this.eventSelect.emit(data)
                // this.searchService.eventSelect.emit(data)
                //console.log(data)
            })
        )

    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.disabled) {
            Object.keys(this.form.controls).forEach((key: string) => {
                this.form.controls[key][this.disabled ? 'disable' : 'enable']()
            })
        }

    }

    ngOnDestroy() {
        isDebugMode ? console.log(`ngOnDestroy()`) : undefined
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe()
        })
    }

    openModal(event, control) {
        console.log('aqui', control)
        if (!this.disabled) {
            this.eventOpenModal.emit(true)
        }
    }

    onBlur(event, controlName) {

        console.log(event.target.value)

        this.eventBlur.emit(event.target.value)

        let $value = event.target.value

        this.form.reset()

        if ($value != '') {
            
            this.form.controls[controlName].setValue($value)

            this.appService.getData(this.tableid, this.form.value, this.keys).subscribe(
                data => {
                    if (data.length > 0) {
                        this.form.patchValue(data[0])
                    } else {
                        this.form.reset()
                    }
                },
                error => {
                    console.log(error)
                })
        }



    }

    selectInput(event) {
        //isDebugMode ? console.log(`selectInput()`) : undefined
        event.target.select()
    }

    onKeydown(event) {
        if (event.key === "Enter") {
            //event.key = "Tab"
            //console.log('Enter')
        }
    }


}
